/**
 * Modelo de filtros do model-map.
 * @category ModelMaps
 * @interface ModelMapFilter
 * @hideconstructor
 */
export class ModelMapFilter {
  field: string;
  operation: string;
  operationValue: string;
  logicalOperator: string;

  constructor(
    field: string,
    operation: string,
    operationValue: string,
    logicalOperator: string
  ) {
    /** Nome do campo filtrado.
     * @type {string}
     */
    this.field = field;
    /** Operação utilizada no filtro.</br>
     * == - Igual </br>
     * < - Menor que </br>
     * > - Maior que </br>
     * in - Contém </br>
     * notin - Não contém </br>
     * blank - Em branco </br>
     * filled - Preenchido
     * @type {string}
     */
    this.operation = operation;
    /** Valor usado na comparação.
     * @type {string}
     */
    this.operationValue = operationValue;
    /** Operação de junção lógica.
     * and - 'E' lógico
     * @type {string}
     */
    this.logicalOperator = logicalOperator;
  }
}



// WEBPACK FOOTER //
// ./src/modules/modelMap/models/ModelMapFilter.ts